import React from 'react';
import styles from './EditAdButton.module.scss';
import {IProduct} from 'data/interfaces/products';
import EditIcon from '@material-ui/icons/Edit';
import LinkBlock from 'gui/components/linkBlock/LinkBlock';
import {generateSluggedEditUrl} from 'data/redux/actions/guiActions';
import {When} from 'react-if';
import {isProductOfStatusType} from 'data/redux/selectors/productSelector';
import {PRODUCT_STATUS_TYPE_EDITABLE} from 'data/redux/constants/productsConstants';
import {Tooltip} from '@material-ui/core';
import CircleLoader from '../circleLoader';

interface IAdProps {
  product: IProduct;
  admin: boolean;
  className?: string;
  loading?: boolean;
}


const EditAdButton = ({loading, ...props}: IAdProps) => loading ? <CircleLoader/> : (
  <When condition={!!props.admin || isProductOfStatusType(props.product, PRODUCT_STATUS_TYPE_EDITABLE)}>
    {() => <LinkBlock
      to={generateSluggedEditUrl(props.product)}
      className={`${styles.controlButton} ${props.className}`}>
      <Tooltip title="עריכה" aria-label="edit" arrow enterDelay={0}>
        <EditIcon/>
      </Tooltip>
    </LinkBlock>}
  </When>
);

EditAdButton.defaultProps = {
  product: {},
  admin: false,
  className: ''
};
export default EditAdButton;
